import React, { useRef } from 'react';
import './about.css'
import AboutPageImage from '../../assets/about-page-img.svg'
import AboutPageDecor from '../../assets/about-page-decor.svg'
import { motion, useInView } from "framer-motion";
const ImageComponent = () => {
    const hiddenMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 30px, rgba(0,0,0,1) 30px, rgba(0,0,0,1) 30px)`;
    const visibleMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 0px, rgba(0,0,0,1) 0px, rgba(0,0,0,1) 30px)`;
    const ref = useRef(null);
    const inView = useInView(ref, { triggerOnce: true, threshold: 0.1 });

    return (
        <div className='about-page-image-component'>
            <motion.div
                ref={ref}
                initial={{ WebkitMaskImage: hiddenMask, maskImage: hiddenMask }}
                animate={
                    inView
                        ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
                        : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
                }
                transition={{ duration: 1, delay: 1 }}>
                <img src={AboutPageImage} alt="Logo with title" className='about-page-image'/>
            </motion.div>
        </div>
    );
}
const About = () => {
    return (
        <div id='about-page' className='about-page' >
            <div className='about-page-para'>
                <img src={AboutPageDecor} alt="Logo with title" className='about-page-decor' />
                <p className='first-text-about'>We are a <span className='gradient-text'>specialized AI engineering team</span> building the intelligent systems of the agentic era.</p>
                <p className='second-text-about'>At TryOuts, we focus exclusively on AI agent development, LLM integration, and intelligent automation. Our engineers have shipped production agent systems across industries - from autonomous customer support pipelines to multi-agent research tools and voice-first business interfaces. Based in India, we work with startups and enterprises globally to turn AI ambition into deployed, working software.</p>
            </div>
            <ImageComponent />
        </div>
    )
}

export default About;